export interface OfferInfo {
  enabled: boolean;
  type: "percentage" | "fixed";
  value: number;
  startDate?: string;
  endDate?: string;
  badge?: string;
  badgeAr?: string;
}

export function isOfferActive(offer?: OfferInfo | null): boolean {
  if (!offer?.enabled || !offer.value) return false;
  const now = new Date();
  if (offer.startDate && new Date(offer.startDate) > now) return false;
  if (offer.endDate && new Date(offer.endDate) < now) return false;
  return true;
}

export function calcDiscountedPrice(originalPrice: number, offer?: OfferInfo | null): number {
  if (!isOfferActive(offer)) return originalPrice;
  if (offer!.type === "percentage") {
    return Math.round(originalPrice * (1 - offer!.value / 100));
  }
  return Math.max(0, originalPrice - offer!.value);
}

export function getDiscountLabel(offer?: OfferInfo | null, isAr = false): string {
  if (!isOfferActive(offer)) return "";
  if (offer!.type === "percentage") {
    return isAr ? `خصم ${offer!.value}%` : `${offer!.value}% OFF`;
  }
  return isAr ? `خصم ${offer!.value} جنيه` : `${offer!.value} EGP OFF`;
}

export function getOfferBadge(offer?: OfferInfo | null, isAr = false): string | undefined {
  if (!isOfferActive(offer)) return undefined;
  if (offer!.badgeAr && isAr) return offer!.badgeAr;
  if (offer!.badge) return offer!.badge;
  return getDiscountLabel(offer, isAr);
}
